<template>
	<div class="page" :style="{height:fixedHeight+'px'}">
		<div class="pageTop">
			<div class="titleView">
				<div class="line"></div>
				<div class="titleName">活动设置</div>
			</div>
			<div class="view">
				<div class="com">
					<div class="mr">活动时间:</div>
					<el-date-picker v-model="dateValue" type="datetimerange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" size="small">
					</el-date-picker>
				</div>
				<div class="com">
					<div class="mr">添加商品:</div>
					<el-button @click="handleSelectClick" size="small">选择</el-button>
				</div>
				<div class="com">
					<div class="mr"></div>
					<el-table :data="tableData" border>
						<el-table-column prop="goods_info.goods_name" label="线上商品名称" :key="1" align="center">
						</el-table-column>
						<el-table-column prop="goods_info.sku_value" label="线上规格" :key="2" align="center">
						</el-table-column>
						<el-table-column prop="goods_info.unit" label="单位" :key="3" align="center">
						</el-table-column>
						<el-table-column prop="goods_info.marking_price" label="售价" :key="4" align="center">
							<template>
								
							</template>
						</el-table-column>
						<el-table-column prop="goods_info.price" label="特价价格" :key="5" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.goods_info.price" :min="1" size="small"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="inventory" label="限购数量" :key="6" align="center">
							<template slot-scope="scope">
								<el-input-number v-model="scope.row.inventory" :min="1" size="small"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column label="操作" :key="10" align="center">
							<template slot-scope="scope">
								<el-button type="text" size="small" @click="handelDeleteClick(scope.$index)">删除
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<div class="pageRightBtn">
			<el-button @click="handleBackClick" size="small">返回</el-button>
			<el-button type="warning" @click="handelSubmitClick" size="small">提交</el-button>
		</div>
		<!-- 添加商品弹框 -->
		<div v-if="dialogOnlineGoods_state">
			<dialogOnlineGoods @closeOn="dialogOnlineGoods_state = false" :onlineState.sync="dialogOnlineGoods_state"
				@submit="selectShop"></dialogOnlineGoods>
		</div>
	</div>
</template>

<script>
	import dialogOnlineGoods from "../../../components/dialog_onlineGoods.vue"
	import {
		addSpecial,
		specialInfo,
		updateSpecial
	} from '../../../api/program.js'
	export default {
		components: {
			dialogOnlineGoods
		},
		data() {
			return {
				id: this.$route.query.id, //对应产品id
				fixedHeight: '',
				title: '', //拼团名称
				dateValue: [], //活动日期
				people: 2, //参团人数
				time_limit: 24, //限时
				tableData: [], //表格数据
				dialogOnlineGoods_state: false, //新增商品弹框状态
				goods: [], //选中商品
			}
		},
		mounted() {
			this.fixedHeight = document.documentElement.clientHeight - 86;
			if (this.id != '') {
				this.getInfoData();
			}
		},
		methods: {
			//获取详情
			getInfoData() {
				let params = {
					id: this.id
				}
				specialInfo(params).then((res) => {
					if (res.code == 0) {
						console.log('详情', res.data)
						this.tableData = [{goods_info:res.data.goods_info,inventory:res.data.inventory}];
						console.log(this.tableData)
						this.dateValue = [res.data.begin_time * 1000, res.data.end_time * 1000]
					}
				})
			},
			//删除商品
			handelDeleteClick(index) {
				this.tableData.splice(index, 1)
			},
			//选中商品
			selectShop(item) {
				console.log('选择商品', item)
				for (let i = 0; i < item.sku_extend_info.length; i++) {
					let obj = {
						goods_info: {
							goods_type: item.goods_type,
							goods_id: item._id,
							goods_name: item.online_name,
							goods_pic: item.cover,
							cover: item.cover,
							sku_id: item.sku_extend_info[i].sku_id,
							sku_value: item.sku_extend_info[i].online_sku_unit_name,
							price: 1,
							marking_price: item.sku_extend_info[i].online_sale_price,
							goods_status: 1,
							packing_way_id: item.sku_extend_info[i].unit_id,
							brand: item.brand_name,
							category_info: {
								category_id: item.online_category_info._id,
								code: item.online_category_info.code,
								name: item.online_category_info.name
							},
							unit: item.sku_extend_info[i].unit_name
						},
						inventory: 1
					}

					this.tableData.push(obj)
				}
				console.log(this.tableData)
			},
			//选择
			handleSelectClick() {
				this.dialogOnlineGoods_state = true;
			},
			//提交
			handelSubmitClick() {
				if (this.tableData.length == 0) {
					this.$message({
						type: 'error',
						message: '请添加商品'
					});
					return
				}
				let startTime = '';
				let endTime = '';
				console.log(this.dateValue)
				if (this.dateValue.length == 0) {
					startTime = '';
					endTime = '';
				} else {
					startTime = new Date(this.dateValue[0]).getTime() / 1000;
					endTime = new Date(this.dateValue[1]).getTime() / 1000;
				}
				let params = {
					begin_time: startTime,
					end_time: endTime,
					
				}
				if (this.id != '') {
					params.goods_info = this.tableData[0].goods_info;
					params.inventory = this.tableData[0].inventory;
					params._id = this.id;
					updateSpecial(params).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已提交'
							});
							this.$router.back();
						}
					})
				} else {
					params.param_list= this.tableData;
					
					addSpecial(params).then((res) => {
						if (res.code == 0) {
							this.$message({
								type: 'success',
								message: '已提交'
							});
							this.$router.back();
						}
					})
				}

			},
			//返回
			handleBackClick() {
				this.$confirm('是否退出当前页面？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$router.back();
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});
			},
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page {
		background: #fff;
		padding: 20px 20px 0 20px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		overflow-y: scroll;

		.titleView {
			display: flex;
			align-items: center;
			padding-bottom: 16px;
			border-bottom: solid 1px #F5F5F5;

			.line {
				width: 2px;
				height: 15px;
				background: #F5882A;
				margin-right: 10px;
			}

			.titleName {
				font-size: 16px;
				color: #2A2A2A;
				font-weight: bold;
			}
		}

		.view {
			flex: 1;
			padding: 20px 0;
			font-size: 14px;

			.mr {
				width: 80px;
			}

			.com {
				display: flex;
				align-items: center;
				margin-bottom: 20px;
			}

			.avatar-uploader .el-upload {
				border: 1px dashed #d9d9d9;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}

			.avatar-uploader .el-upload:hover {
				border-color: #409EFF;
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				width: 148px;
				height: 148px;
				line-height: 148px;
				text-align: center;
			}

			.avatar {
				width: 148px;
				height: 148px;
				display: block;
				object-fit: cover;
			}
		}

		.pageRightBtn {
			height: 90px;
			text-align: right;
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}
	}

	.page::-webkit-scrollbar {
		display: none;
	}
</style>
